const state = {
  permissions: [],
}
const mutations = {
  setPermissions(state, permissions) {
    state.permissions = permissions;
    console.log('setPermissions', permissions);
  },
}

const getters = {
  getPermissions(state) {
    return state.permissions
  }
}
export default {
  state, mutations,getters
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js